var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTabletAltActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0938 0H3.90625C2.6123 0 1.5625 1.0498 1.5625 2.34375V22.6562C1.5625 23.9502 2.6123 25 3.90625 25H21.0938C22.3877 25 23.4375 23.9502 23.4375 22.6562V2.34375C23.4375 1.0498 22.3877 0 21.0938 0ZM12.5 23.4375C11.6357 23.4375 10.9375 22.7393 10.9375 21.875C10.9375 21.0107 11.6357 20.3125 12.5 20.3125C13.3643 20.3125 14.0625 21.0107 14.0625 21.875C14.0625 22.7393 13.3643 23.4375 12.5 23.4375ZM21.0938 18.1641C21.0938 18.4863 20.8301 18.75 20.5078 18.75H4.49219C4.16992 18.75 3.90625 18.4863 3.90625 18.1641V2.92969C3.90625 2.60742 4.16992 2.34375 4.49219 2.34375H20.5078C20.8301 2.34375 21.0938 2.60742 21.0938 2.92969V18.1641Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTabletAltActive);
export default __webpack_public_path__ + "static/media/icon-tablet-alt-active.71aa4ab7cb5adbff41a3df32d869e31e.svg";
export { ForwardRef as ReactComponent };